// Version : 1.0.0
// Author : AGALYA
import CoApplicantActionType from './co-applicant.types';

/** ***************** CO-APPLICANT DETAILS OPERATIONS START *********************** */
export const addCoApplicantDetailsStart = (addCoApplicant: any) => ({
	type: CoApplicantActionType.ADD_CO_APPICANT_DETAILS_START,
	payload: addCoApplicant,
});

export const updateCoApplicantDetailsStart = () => ({
	type: CoApplicantActionType.UPDATE_CO_APPICANT_DETAILS_START,
});

export const removeCoApplicantDetailsStart = (removeCoApplicant: any) => ({
	type: CoApplicantActionType.REMOVE_CO_APPICANT_DETAILS_START,
	payload: removeCoApplicant,
});

export const updateCoApplicantDetailsArrStart = (updateCoApplicantArr: any) => ({
	type: CoApplicantActionType.UPDATE_CO_APPLICANT_ARR_START,
	payload: updateCoApplicantArr,
});
/** ***************** CO-APPLICANT DETAILS OPERATIONS END *********************** */

/** ***************** UPDATE CO-APPLICANT START *********************** */
export const updateCoApplicantStart = (coApplicantCredentials: any) => ({
	type: CoApplicantActionType.UPDATE_CO_APPLICANT_START,
	payload: coApplicantCredentials,
});

export const updateCoApplicantSuccess = (coApplicantSuccess: any) => ({
	type: CoApplicantActionType.UPDATE_CO_APPLICANT_SUCCESS,
	payload: coApplicantSuccess,
});

export const updateCoApplicantFailure = (coApplicantFailure: unknown) => ({
	type: CoApplicantActionType.UPDATE_CO_APPLICANT_FAILURE,
	payload: coApplicantFailure,
});

export const updateCoApplicantResponseResetStart = () => ({
	type: CoApplicantActionType.UPDATE_CO_APPLICANT_RESPONSE_REST_START,
});

export const updateCoApplicantResponseChanged = () => ({
	type: CoApplicantActionType.UPDATE_CO_APPLICANT_RESPONSE_CHANGED,
});
/** ***************** UPDATE CO-APPLICANT END *********************** */

/** ***************** ADD CO-BORROWER START *********************** */
export const addCoBorrowerStart = (coApplicantCredentials: any) => ({
	type: CoApplicantActionType.ADD_COBORROWER_START,
	payload: coApplicantCredentials,
});

export const addCoBorrowerSuccess = (coApplicantSuccess: any) => ({
	type: CoApplicantActionType.ADD_COBORROWER_SUCCESS,
	payload: coApplicantSuccess,
});

export const addCoBorrowerFailure = (coApplicantFailure: unknown) => ({
	type: CoApplicantActionType.ADD_COBORROWER_FAILURE,
	payload: coApplicantFailure,
});

export const addCoBorrowerResponseResetStart = () => ({
	type: CoApplicantActionType.ADD_COBORROWER_RESPONSE_RESET_START,
});

export const addCoBorrowerResponseChanged = () => ({
	type: CoApplicantActionType.ADD_COBORROWER_RESPONSE_CHANGED,
});
/** ***************** ADD CO-BORROWER END *********************** */

/** ***************** FETCH CO-BORROWER START *********************** */
export const fetchCoBorrowerStart = (coApplicantCredentials: any) => ({
	type: CoApplicantActionType.FETCH_COBORROWER_START,
	payload: coApplicantCredentials,
});

export const fetchCoBorrowerSuccess = (coApplicantSuccess: any) => ({
	type: CoApplicantActionType.FETCH_COBORROWER_SUCCESS,
	payload: coApplicantSuccess,
});

export const fetchCoBorrowerFailure = (coApplicantFailure: unknown) => ({
	type: CoApplicantActionType.FETCH_COBORROWER_FAILURE,
	payload: coApplicantFailure,
});

export const fetchCoBorrowerResponseResetStart = () => ({
	type: CoApplicantActionType.FETCH_COBORROWER_RESPONSE_RESET_START,
});

export const fetchCoBorrowerResponseChanged = () => ({
	type: CoApplicantActionType.FETCH_COBORROWER_RESPONSE_CHANGED,
});
/** ***************** FETCH CO-BORROWER END *********************** */

/** ***************** DELETE CO-APPLICANT START *********************** */
export const deleteCoBorrowerStart = (coApplicantCredentials: any) => ({
	type: CoApplicantActionType.DELETE_CO_APPLICANT_START,
	payload: coApplicantCredentials,
});

export const deleteCoBorrowerSuccess = (coApplicantSuccess: any) => ({
	type: CoApplicantActionType.DELETE_CO_APPLICANT_SUCCESS,
	payload: coApplicantSuccess,
});

export const deleteCoBorrowerFailure = (coApplicantFailure: unknown) => ({
	type: CoApplicantActionType.DELETE_CO_APPLICANT_FAILURE,
	payload: coApplicantFailure,
});

export const deleteCoBorrowerResponseResetStart = () => ({
	type: CoApplicantActionType.DELETE_CO_APPLICANT_RESPONSE_REST_START,
});

export const deleteCoBorrowerResponseChanged = () => ({
	type: CoApplicantActionType.DELETE_CO_APPLICANT_RESPONSE_CHANGED,
});
/** ***************** DELETE CO-APPLICANT END *********************** */

export const coBorrowerObjReset = () => ({
	type: CoApplicantActionType.COBORROWER_OBJECT_RESET,
});

/** ***************** HIGHMARK CHECK CO-BORROWER START *********************** */
export const checkCoBorrowerHighMarkStart = (coApplicantCredentials: any) => ({
	type: CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_START,
	payload: coApplicantCredentials,
});

export const checkCoBorrowerHighMarkSuccess = (coApplicantSuccess: any) => ({
	type: CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_SUCCESS,
	payload: coApplicantSuccess,
});

export const checkCoBorrowerHighMarkFailure = (coApplicantFailure: unknown) => ({
	type: CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_FAILURE,
	payload: coApplicantFailure,
});

export const checkCoBorrowerHighMarkRespResetStart = () => ({
	type: CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_RESPONSE_RESET_START,
});

export const checkCoBorrowerHighMarkRespChanged = () => ({
	type: CoApplicantActionType.CHECK_COBORROWER_HIGHMARK_RESPONSE_CHANGED,
});
/** ***************** HIGHMARK CHECK CO-BORROWER END *********************** */

/** ***************** VERIFY CO-APPLICANT AADHAAR OTP START *********************** */
export const verifyCoApplicantAadharOtpStart = (DetailsCredentials: any) => ({
	type: CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_START,
	payload: DetailsCredentials,
});

export const verifyCoApplicantAadharOtpSuccess = (DetailsSuccess: any) => ({
	type: CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_SUCCESS,
	payload: DetailsSuccess,
});

export const verifyCoApplicantAadharOtpFailure = (DetailsFailure: unknown) => ({
	type: CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_FAILURE,
	payload: DetailsFailure,
});

export const verifyCoApplicantAadharOtpResponseResetStart = () => ({
	type: CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_RESPONSE_RESET_START,
});

export const verifyCoApplicantAadharOtpResponseChanged = () => ({
	type: CoApplicantActionType.VERIFY_CO_APPLICANT_AADHAR_OTP_RESPONSE_CHANGED,
});
/** ***************** VERIFY CO-APPLICANT AADHAAR OTP END *********************** */

/** ***************** VERIFY VALIDATE CO-APPLICANT AADHAAR OTP START *********************** */
export const verifyValidateCoApplicantAadharOtpStart = (DetailsCredentials: any) => ({
	type: CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_START,
	payload: DetailsCredentials,
});

export const verifyValidateCoApplicantAadharOtpSuccess = (DetailsSuccess: any) => ({
	type: CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_SUCCESS,
	payload: DetailsSuccess,
});

export const verifyValidateCoApplicantAadharOtpFailure = (DetailsFailure: unknown) => ({
	type: CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_FAILURE,
	payload: DetailsFailure,
});

export const verifyValidateCoApplicantAadharOtpResponseResetStart = () => ({
	type: CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_RESPONSE_RESET_START,
});

export const verifyValidateCoApplicantAadharOtpResponseChanged = () => ({
	type: CoApplicantActionType.VERIFY_VALIDATE_CO_APPLICANT_AADHAR_OTP_RESPONSE_CHANGED,
});
/** ***************** VERIFY VALIDATE CO-APPLICANT AADHAAR OTP END *********************** */
